import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import CalculatorReducer from './reducers/CalculatorReducer'

export default combineReducers({
	routing: routerReducer,
	calculator: CalculatorReducer
})


// WEBPACK FOOTER //
// ./src/reducer.js